/**
 * @generated SignedSource<<c851b1f63014440fe81ed9b940449127>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpaceIndicator_space$data = {
  readonly color: {
    readonly dark: string;
    readonly light: string;
  };
  readonly icon: {
    readonly name?: string;
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "SpaceIndicator_space";
};
export type SpaceIndicator_space$key = {
  readonly " $data"?: SpaceIndicator_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpaceIndicator_space",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/)
          ],
          "type": "NamedIcon",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Color",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "light",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dark",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};
})();

(node as any).hash = "d869192dc0f40d2d03356107b78410a7";

export default node;
